// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/popover.js
import Overlay from "./overlay"
let overlayId = 0

export default class Popover extends Overlay {
  static componentName = "popover"
  static defaults = { ...Overlay.defaults, trigger: "click", placement: "right" }

  createTip() {
    const title = this.config.title || this.element.dataset.coreuiOriginalTitle || ""
    const content = this.config.content || ""
    if (!title && !content) return null
    const tip = document.createElement("div")
    tip.id = `coreui-popover-${++overlayId}`
    tip.className = "popover fade"
    tip.setAttribute("role", "tooltip")
    tip.innerHTML = '<div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div>'
    const header = tip.querySelector(".popover-header")
    if (title) this.setContent(header, title)
    else header.remove()
    this.setContent(tip.querySelector(".popover-body"), content)
    return tip
  }
}
